import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import React, { useEffect, useState } from 'react';
import { WrappedInputNumberWithLabel } from '../input';
import LabelWrapper from '../LabelWrapper.component';

export const WeightField = ({
	weight,
	onChange,
	onFocus,
	doValidation = true,
}) => {
	const weightValues = isObject(weight) ? weight : { ounces: 0, pounds: 0 };
	const [pounds, setPounds] = useState(weightValues.pounds);
	const [ounces, setOunces] = useState(weightValues.ounces);
	const [validation, setValidation] = useState(false);

	// Flag to block useEffect from running on initial render. No onChange call is needed on load.
	const [firstTimeChange, setFirstTimeChange] = useState(true);

	useEffect(() => {
		if (!firstTimeChange) {
			const changeTimer = setTimeout(() => {
				if (doValidation) {
					setValidation(pounds === 0 && ounces === 0);
				}

				if (isFunction(onChange)) {
					const updatedWeight = { pounds, ounces };

					onChange(updatedWeight);
				}
			}, 700);

			return () => clearTimeout(changeTimer);
		} else {
			setFirstTimeChange(false);
		}
	}, [pounds, ounces]);

	useEffect(() => {
		const newWeightValues = isObject(weight)
			? weight
			: { ounces: 0, pounds: 0 };
		setPounds(newWeightValues.pounds);
		setOunces(newWeightValues.ounces);
	}, [weight]);

	const onChangeInput = ({ target: { name, value } }) => {
		if (name === 'pounds') {
			setPounds(value);
		} else if (name === 'ounces') {
			setOunces(value);
		}
	};

	const showLabelAfter = true;

	return (
		<div className="common-ui-weight-field">
			<WrappedInputNumberWithLabel
				className="weight-input"
				errorMessage="Pounds and ounces can't be zero/empty at the same time"
				isInputInvalid={doValidation ? validation : false}
				label="lbs."
				showLabelAfter={showLabelAfter}
				uiElementConfig={{
					value: pounds,
					className: 'weight-input',
					inputClassName: doValidation && validation ? 'invalid-component' : '',
					showButtons: true,
					min: 0,
					onChange: onChangeInput,
					onFocus,
					name: 'pounds',
					minFractionDigits: 0,
					maxFractionDigits: 2,
					useGrouping: false,
					dataqa: 'weightfield-pounds',
				}}
			/>
			<WrappedInputNumberWithLabel
				className="weight-input"
				errorMessage="Pounds and ounces can't be zero/empty at the same time"
				isInputInvalid={doValidation ? validation : false}
				label="oz."
				showLabelAfter={showLabelAfter}
				uiElementConfig={{
					value: ounces,
					className: 'weight-input',
					inputClassName: doValidation && validation ? 'invalid-component' : '',
					showButtons: true,
					min: 0,
					onChange: onChangeInput,
					onFocus,
					name: 'ounces',
					minFractionDigits: 0,
					maxFractionDigits: 2,
					useGrouping: false,
					dataqa: 'weightfield-ounces',
				}}
			/>
		</div>
	);
};

export const WeightFieldWithLabel = LabelWrapper(
	WeightField,
	'common-ui-weight-field-wrapper'
);
